import { Flex, Image, Text } from "@fluentui/react-northstar";
import React from "react";
import ImgForEmptyData from "../../../assets/illustrations/offboarding/ImgForEmptyData.svg";
import styled from "styled-components";

export default function EmptyTableData({ activeTab }) {
    const EmptyDataText = () => {
        switch (activeTab) {
            case 0:
                return "Aucun Processus d'offboarding à préparer";
            case 1:
                return "Aucun Processus d'offboarding en cours";
            case 2:
                return "Aucun Processus d'offboarding à archiver";
            default:
                return "Aucun Processus d'offboarding à démarrer";
        }
    };
    return (
        <EmptyFlex gap={"gap.medium"} column fill hAlign="center">
            <Image src={ImgForEmptyData} alt="empty data" />
            <TextStyle content={EmptyDataText(activeTab)} />
        </EmptyFlex>
    );
}

const TextStyle = styled(Text)`
    color: #000;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
`;

const EmptyFlex = styled(Flex)`
    padding-block: 26px 70px;
`;
